import React, { useState } from 'react';
import PageTitle from '../../components/PageTitle';
import ScreenTimeStatistics from '../ScreenTimeStatistics';
import OpenAiUsage from './components/OpenAiUsage';
import './css/index.scss';

const TABS = {
  screens: 'screens',
  ai: 'ai',
};

function Statistics() {
  const [tab, setTab] = useState(TABS.screens);

  return (
    <div className="statistics_page">
      <PageTitle text="Статистика" />

      <div className="statistics_page_tabs" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === TABS.screens}
          className={`statistics_page_tab ${tab === TABS.screens ? 'active' : ''}`}
          onClick={() => setTab(TABS.screens)}
        >
          Экраны
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === TABS.ai}
          className={`statistics_page_tab ${tab === TABS.ai ? 'active' : ''}`}
          onClick={() => setTab(TABS.ai)}
        >
          Использование ИИ
        </button>
      </div>

      {tab === TABS.screens ? <ScreenTimeStatistics embedded /> : null}
      {tab === TABS.ai ? <OpenAiUsage /> : null}
    </div>
  );
}

export default Statistics;
